
const CONFIG = {
  //"deBug"：本地开发，"service"：4.0生产 "serviceTestMX5"：5.0uat，  "serviceTestMX5Sit" 5.0sit
  //"serviceMX5"：5.0生产，"serviceTestVer"：测试 "serviceTestSit"：4.0sit "serviceTestUat"：4.0uat

  // 测试
  serviceType: "serviceTestSit",  //  测试
  // serviceType: "service", // 正式
  // // 生产
   //serviceType: "service",   //5.0
  isPcTest:1,//1代表是pc调试，0代表不是
  "transferProtocol": "https://",
  "version": "1.0.1",
  "ok": 1,
  // 支持的所有多语言, 用逗号分隔, 如zh,en
  LANGUAGES: 'zh-CN,en-US,ja-JP',
  // 默认使用的语言
  DEFAULT_LANGUAGE: 'zh-CN',
  token: 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJpc3MiOiJieXgtY2hhbm5lbC1qd3QiLCJzdWIiOiIxMDAwMjAwMDcwMDAwMDAwMDA2IiwiYXVkIjoiY2hhbm5lbCIsImV4cCI6MTYwMjIwOTMxMSwibmJmIjoxNjAwOTEyNDExLCJpYXQiOjE2MDA5MTMzMTEsInVzZXJJZCI6IjEwMDAyMDAwNzAwMDAwMDAwMDYiLCJzY2hvb2xDb2RlIjoiMjAwMDcifQ.lNChhts12Dm8Vzf2SGREXJMCFlDL2AqzSQJ__sL170T1uEd7U677YENkY457i8-dfuLfXbi8s-cLX1Ci03KS4A',//当前用户token
  schoolCode:"20007",//学校编码
  channel:'0',//渠道标识
}
export default CONFIG



// WEBPACK FOOTER //
// ./src/data/config.js